import React from 'react';

// debounce timeout in milliseconds
const SEARCH_TIMEOUT = 700;

export default function useDebounceSearch(onSearch, value) {
    const timeoutRef = React.useRef(null);
    const [searchQuery, setSearchQuery] = React.useState('');

    React.useEffect(() => {
        setSearchQuery('');
    }, [value]);

    // clear the timeout if it exists at unmount
    React.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    // debounce search on input
    const setSearch = React.useCallback(
        (event, data) => {
            const searchQuery = data ? data.searchQuery : event;

            setSearchQuery(searchQuery);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                onSearch(searchQuery);
            }, SEARCH_TIMEOUT);
        },
        [timeoutRef, setSearchQuery, onSearch]
    );

    return [searchQuery, setSearch];
}
